<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form class="admin-forms" [formGroup]="addTaxForm">
  <div class="accordion-class">
    <h5>Create Tax</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group driver-truck">
      <div class="row mtb">
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Tax Name:</mat-label>
            <input
              matInput
              formControlName="tax_name"
              required
              style="text-transform: uppercase"
            />
            <mat-error>Please Enter Tax Name</mat-error>
          </mat-form-field>
        </div>
        <!-- hsn code  -->
        <div class="col-md-6" *ngIf="data?.type === 'customerGST'">
          <mat-form-field>
            <mat-label>HSN Code:</mat-label>
            <input
              matInput
              formControlName="hsn_code"
              required
            />
            <mat-error>Please Enter HSN Code</mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Normal Tax and Type  -->
      <div class="row mtb" *ngIf="data?.type !== 'customerGST'">
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Tax Deduction:</mat-label>
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="tax_deduction"
              required
            />
            <mat-error>Please Enter Tax Deduction</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6 tax-container">
          <mat-form-field>
            <mat-select
              dropLocationSearchField
              formControlName="tax_type"
              placeholder="Tax Type"
              (selectionChange)="getTaxtype($event)"
              required
            >
              <mat-option value="percent">PERCENT</mat-option>
              <mat-option value="amount">AMOUNT</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- fcm/rcm  -->
      <div class="row mtb" *ngIf="data?.type === 'customerGST'">
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>RCM Deduction (%):</mat-label>
            <input
              matInput
              formControlName="rcm_deduction"
              appTwoDigitDecimaNumber
              required
            />
            <mat-error>Please Enter RCM Deduction</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>FCM Deduction (%):</mat-label>
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="fcm_deduction"
              required
            />
            <mat-error>Please Enter FCM Deduction</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mt-3">
        <mat-form-field>
          <mat-label>Comments</mat-label>
          <input matInput formControlName="tax_description" required />
          <mat-error>Please Enter Comments</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
  <button
    type="submit"
    class="button buttonBlue"
    [class.spinner]="loading"
    [disabled]="loading"
    (click)="addTax()"
  >
    Save
  </button>
</form>
